import React from "react";
import { FaCcStripe, FaCreditCard, FaAlipay } from "react-icons/fa";

export default [
  {
    page: "products",
    label: "payments",
    url: `/products/payments`,
    icon: <FaCreditCard className="icon" />,
  },
  {
    page: "products",
    label: "terminal",
    url: `/products/payments`,
    icon: <FaCreditCard className="icon" />,
  },
  {
    page: "products",
    label: "connect",
    url: `/products/payments`,
    icon: <FaCreditCard className="icon" />,
  },
  {
    page: "products",
    label: "billing",
    url: `/products/payments`,
    icon: <FaCreditCard className="icon" />,
  },
  {
    page: "developers",
    label: "documentation",
    url: `/products/payments`,
    icon: <FaAlipay className="icon" />,
  },
  {
    page: "developers",
    label: "libraries",
    url: `/products/payments`,
    icon: <FaAlipay className="icon" />,
  },
  {
    page: "developers",
    label: "plugins",
    url: `/products/payments`,
    icon: <FaAlipay className="icon" />,
  },
  {
    page: "company",
    label: "jobs",
    url: `/products/payments`,
    icon: <FaCcStripe className="icon" />,
  },
  {
    page: "company",
    label: "customers",
    url: `/products/payments`,
    icon: <FaCcStripe className="icon" />,
  },
];
